export class DeliveryDateModel {
  public dateNumber?: number;
  public date: Date = new Date();
  public totalDelivery?: number | null = null;
  public isDelivery?: boolean;
  public id?: number;
  public isWorkOff: boolean = false;
  public isAfter11h: boolean = false;
  public dateDeadlineWarehouse: Date = new Date();

  constructor(init?: Partial<DeliveryDateModel>) {
    Object.assign(this, init);
  }
}
